import { Star, Quote } from 'lucide-react';

interface ReviewCardProps {
  name: string;
  rating: number;
  review: string;
  date: string;
  delay?: number;
}

const ReviewCard = ({ name, rating, review, date, delay = 0 }: ReviewCardProps) => {
  return (
    <div 
      className="glow-card p-6 opacity-0 animate-fade-in"
      style={{ animationDelay: `${delay}ms`, animationFillMode: 'forwards' }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={`w-4 h-4 ${
                i < rating ? 'fill-[hsl(45_93%_47%)] text-[hsl(45_93%_47%)]' : 'text-border'
              }`}
            />
          ))}
        </div>
        <Quote className="w-8 h-8 text-border" />
      </div>
      <p className="text-foreground/80 text-sm leading-relaxed mb-4 line-clamp-4">
        "{review}"
      </p>
      <div className="flex items-center justify-between">
        <span className="font-medium text-foreground">{name}</span>
        <span className="text-xs text-muted-foreground">{date}</span>
      </div>
    </div>
  );
};

export default ReviewCard;
